import { Observable } from 'rxjs';
import { Router, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { NgForm } from '@angular/forms';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { JobsDbService } from '../jobs-db.service';
import { Job } from 'src/app/job.model';
import { finalize } from 'rxjs/operators';
import moment from 'moment';
import { AngularFireStorage } from '@angular/fire/storage';

@Component({
  selector: 'app-jobs-edit',
  templateUrl: './jobs-edit.component.html',
  styleUrls: ['./jobs-edit.component.scss']
})
export class JobsEditComponent implements OnInit {
  modalVisible: boolean = false;
  form: FormGroup;
  singleJob;

  uploadPercent: Observable<number>;
  downloadURL: Observable<string | null>;

  public Editor = ClassicEditor;
  public model = {
    editorData: ``
  };

  constructor(private jobsDbService: JobsDbService, private router: Router, private route: ActivatedRoute, private storage: AngularFireStorage) { }

  ngOnInit() {
    const key = this.route.snapshot.params['id'];
    this.jobsDbService.getSingleJob(key).subscribe(res => {
      this.singleJob = res;
      this.model.editorData = this.singleJob.body;
      this.form.patchValue({
        key: this.singleJob.key,
        title: this.singleJob.title,
        teaser: this.singleJob.teaser,
        image: this.singleJob.image,
        body: this.singleJob.body,
        show: this.singleJob.show
      });
    });

    this.form = new FormGroup({
      key: new FormControl(null),
      title: new FormControl('', {validators: [Validators.required, Validators.minLength(5)]}),
      teaser: new FormControl('', {validators: [Validators.required, Validators.minLength(10)]}),
      image: new FormControl(this.downloadURL),
      body: new FormControl(this.model.editorData, {validators: [Validators.required]}),
      show: new FormControl(null),
      removed : new FormControl(null)

    });
  }

  onSubmit() {
    this.jobsDbService.updateSingleJob(this.form.value);
  }

  uploadFile(event) {
    const file = event.target.files[0];
    const fileName = this.generateRandomName();
    const today = moment().format('YYYY-MM-DD');
    const filePath = 'images/jobs/' + today + '-' + fileName;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    // observe percentage changes
    this.uploadPercent = task.percentageChanges();
    // get notified when the download URL is available
    task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().toPromise().then(res => {
              this.form.patchValue({
                image: res
              })
            })
        })
     )
    .subscribe()
  }

  generateRandomName() {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 10; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  onPreview(){
    this.modalVisible = !this.modalVisible;
    if(this.modalVisible === true){
      window.scroll(0,0);
    }
  }

}
